export interface DisplayColumn {
  name: string;
  label: string;
  custom?: boolean;
  hide?: boolean;
}

export interface DisplayHeader {
  name: string;
  label: string;
  colspan?: number;
  rowspan?: number;
}
export const getPropertyValue = (element: any, property: any) =>
  property.split('.').reduce((object: any, property: any) => object && object[property], element);

export const createOrWhereFilter = (fields: string[], search: string) => ({
  or: fields?.reduce((acc: any, field: any, index: number) => {
    return { ...acc, [index]: { [field]: { ilike: '%' + search + '%' } } };
  }, {}),
});
